export default "__VITE_ASSET__DkN7AXxF__"